import styled from 'styled-components';
import { Skeleton } from '#/shared/components/Skeletons/styled';

export const StopSignListSkeletonWrapper = styled.div`
  align-items: center;
  display: flex;
  flex: 0;
  margin: ${props =>
    props.needsIOSStyles ? 'calc(19% - 20px) 0 calc(5% - 20px)' : '0.5em'};
  margin-top: ${props => (props.first && props.needsIOSStyles ? '16px' : null)};
`;

export const StopSignListSkeletonCircle = styled(Skeleton).attrs(() => ({
  borderRadius: '0.5rem',
  circle: true,
  containerClassName: 'basic-flex',
  enableAnimation: false,
  height: '32px',
  width: '32px',
}))`
  margin-right: 0.5em;
`;

export const StopSignListSkeletonLine = styled(Skeleton).attrs(() => ({
  borderRadius: '0.5rem',
  containerClassName: 'skeleton-flex-1',
  height: '0.9rem',
}))`
  align-self: center;
  margin-right: 0.5em;
`;
